import { gql } from "@apollo/client";

export const GET_REQUESTER_PROFILE = gql`
  fragment RoleRateFragment on roleRate {
    id
    roleName
    roleId
    startDate
    endDate
    account {
      id
      logo
      accountName
    }
    isDayRate
    isUncalculatedRate
  }

  query getRequesterProfile($userId: ID!) {
    requesterProfile(userId: $userId) {
      id
      account {
        id
        briefingTemplates(
          orderByColumn: "identifier"
          orderByDirection: "ASC"
        ) {
          id
          identifier
          content
          createdAt
        }
        uniformTemplates {
          id
          identifier
          items
          createdAt
        }
        venues {
          id
          name
          address
          meetingPoint
          directions
          lat
          lng
          createdAt
          isPinCodeCheckInEnabled
          isQrCodeCheckInEnabled
        }
        roleRates(accountType: requester) {
          ...RoleRateFragment
        }
        isRebookingEnabled
      }
    }
  }
`;
